/* eslint-disable no-console, import/no-commonjs */

'use strict';

module.exports = require('./logger');
